import { render, staticRenderFns } from "./ActivitiesListingRelatedItem.vue?vue&type=template&id=03133ffe&scoped=true&"
import script from "./ActivitiesListingRelatedItem.vue?vue&type=script&lang=js&"
export * from "./ActivitiesListingRelatedItem.vue?vue&type=script&lang=js&"
import style0 from "./ActivitiesListingRelatedItem.vue?vue&type=style&index=0&id=03133ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03133ffe",
  null
  
)

export default component.exports